import { QuestionType } from 'typescript/enums/QuestionType.d';

import { type QuestionFillInTheBlanks } from 'api/types/ChapterContent/QuestionFillInTheBlanks';
import { type RawQuestionFillInTheBlanks } from 'api/types/ChapterContent/QuestionFillInTheBlanks/RawQuestionFillInTheBlanks';

export const parseBlanks = (data: RawQuestionFillInTheBlanks): Omit<QuestionFillInTheBlanks, 'image'> => {
  return {
    correctAnswers: data.answer
      .filter((answer) => {
        return answer.length > 0;
      })
      .slice(0, data.question.split('[blank]').length - 1),
    correctAnswerText: data.correctAnswerText,
    id: data.UPID,
    incorrectAnswerText: data.incorrectAnswerText,
    pageNumber: data.pageNumber,
    question: data.question,
    title: data.question,
    type: QuestionType.QuestionFillInTheBlanks,
  };
};
